import { GridFeatureMode, GridPaginationModel, useGridApiContext } from '@mui/x-data-grid';
import { useAppDispatch } from 'app/hooks';
import { setPaginationModel } from 'common/components/PalmDataGrid/palmDataGridSlice';
import { PaginationMode } from 'common/constants/paginationMode';

export function useUpdatePalmDataGridPage() {
    const dispatch = useAppDispatch();
    const apiRef = useGridApiContext();

    const updatePalmDataGridPage = (paginationMode: GridFeatureMode, pageNumber: number, paginationModel?: GridPaginationModel) => {
        if (paginationMode == PaginationMode.Client) {
            apiRef.current.setPage(pageNumber);
        } else {
            dispatch(setPaginationModel({ page: pageNumber, pageSize: paginationModel?.pageSize ?? 10 }));
        }
    };

    return { updatePalmDataGridPage };
}
